"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatOpenMode = void 0;
var ChatOpenMode;
(function (ChatOpenMode) {
    ChatOpenMode[ChatOpenMode["Chat"] = 0] = "Chat";
    ChatOpenMode[ChatOpenMode["SOF"] = 1] = "SOF";
    ChatOpenMode[ChatOpenMode["PendingDocuments"] = 2] = "PendingDocuments";
})(ChatOpenMode || (exports.ChatOpenMode = ChatOpenMode = {}));
//# sourceMappingURL=chat.intefaces.js.map